import type { FunctionComponent } from 'react';

import { Button, ButtonSize } from '../../../shared/components/button/button';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Thumbnail } from '../../../shared/components/thumbnail/thumbnail';
import { useSignIn } from '../../../shared/hooks/use-sign-in';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { useGameData } from '../../hooks/use-game-data';

import styles from './game-mode-selection.module.scss';

const style = createStyleHelper(styles, 'game-mode-selection');

export interface IGameModeSelectionProps {
    className?: string;
    slugs: string[];
}

export const GameModeSelection: FunctionComponent<IGameModeSelectionProps> = ({
    className,
    slugs,
}) => {
    const { slots } = useGameData({
        initialSlugs: slugs,
    });
    const onPlayForReal = useSignIn();

    const game = slots[0].game;

    if (!game) {
        return null;
    }

    return (
        <div className={createClassName([className, style()])}>
            <Thumbnail
                className={style('game')}
                key={game.id}
                slug={game.slug}
                title={game.name}
                background={game.thumbnails[0].background || ''}
                logo={game.thumbnails[0].logo}
                asset={game.thumbnails[0].asset}
                variant={game.thumbnails[0]?.layout?.variant}
            />
            <div className={style('buttons')}>
                <Button className={style('button')} size={ButtonSize.LARGE} onClick={onPlayForReal}>
                    <FormattedMessage
                        id="gameplay.game-mode-selection.play-for-real"
                        defaultMessage="PLAY FOR REAL"
                    />
                </Button>
                <Button
                    className={style('button')}
                    size={ButtonSize.LARGE}
                    hollow
                    light
                    href="?realmoney=false"
                >
                    <FormattedMessage
                        id="gameplay.game-mode-selection.play-for-fun"
                        defaultMessage="PLAY FOR FUN"
                    />
                </Button>
            </div>
        </div>
    );
};
